// extracted by mini-css-extract-plugin
export default {"monthCellWrapper":"MonthCell_monthCellWrapper__t08R-","weekDaysWrapper":"MonthCell_weekDaysWrapper__dhMIU"};